import introduction0 from './introduction0.png'
import introduction1 from './introduction1.png'
import introduction2 from './introduction2.png'
import introduction3 from './introduction3.png'
import introduction4 from './introduction4.png'
import introduction5 from './introduction5.png'
import introduction6 from './introduction6.png'
import introduction7 from './introduction7.png'

let iconList = [
    {
        image: introduction0,
        tips: null,
        name: '地上、BS、CS48局ライブTV<br/>＆30分タイムシフト'
    },
    {
        image: introduction1,
        tips: null,
        name: '地上、BS、CS48局<br/>過去４週間番組見逃し視聴'
    },
    {
        image: introduction2,
        tips: null,
        name: '週間視聴ランキング<br/>ビデオ毎月600本'
    },
    {
        image: introduction3,
        tips: null,
        name: 'スマートフォン、fireTV Stick、<br/>Googleplay端末対応'
    },
    {
        image: introduction4,
        tips: null,
        name: 'CDNサーバー配置<br/>海外どこでも安定配信'
    },
    {
        image: introduction5,
        tips: '※モバイル版アプリのみ限定',
        name: '過去4週間番組予約録画<br/>好きなタイミングで視聴可能'
    },
    {
        image: introduction6,
        tips: null,
        name: 'アプリをダウンロードして<br/>7日間無料トライアル'
    },
    {
        image: introduction7,
        tips: null,
        name: 'スマホ、テレビ上で簡単<br/>インターネット決済機能'
    }
]
export {
    iconList as iconList
}